import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/docs/getting-started/GettingStartedPage.tsx");
